module.exports = __webpack_public_path__ + "img/绑定微信logo.6781ddb0.png";